import { getPlatformComponent } from '@direct-frontend/platform-code';

export const Combobox = getPlatformComponent({
    desktop: import('./Combobox@desktop'),
    mobile: import('./Combobox@mobile'),
});
